// Seeded RNG for deterministic gameplay

export class SeededRNG {
  private state: number;

  constructor(seed: number) {
    this.state = seed;
  }

  // Mulberry32 algorithm
  next(): number {
    let t = (this.state += 0x6d2b79f5);
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }

  // Random integer in [min, max]
  nextInt(min: number, max: number): number {
    return Math.floor(this.next() * (max - min + 1)) + min;
  }

  // Random float in [min, max)
  nextFloat(min: number, max: number): number {
    return this.next() * (max - min) + min;
  }
}
